
<div *ngIf="eventInfo">

    <div class="text-center" style="top:0; z-index:999;">
        <img
            id="company-registor-banner-image"
            [src]="eventInfo.bannerUrl"
            class="img-fluid"
            style="border-radius: 12px;">
    </div>

    <div class="container d-flex justify-content-center login-box">
        <div *ngIf=eventInfo 
            id="login-card" 
            class="my-auto justify-content-center border card-form"
            style="width: 612px;">
            
            <h4 id="login-title-text" 
                class="d-flex justify-content-center text-center">
                {{loginType | titlecase}} Login</h4>
            <p id="login-period-text" class="text-muted mb-3 text-center">You can adjust detail from {{formatEventPeriod(eventInfo)}}</p>

            <div id="login-event-warning-text" class="alert alert-danger" role="alert" *ngIf="!canLogin" [innerHTML]="eventTextWarning">
            </div>
            <div class="mt-4" *ngIf="canLogin">
                <form [formGroup]=form>
                    <label id="login-field-email-text" for="login-field-email-input" class="col-form-label">
                        Username <span class="text-danger">*</span>
                    </label>
                    <input id="login-field-email-input" 
                        type="text" 
                        class="form-control mb-2" 
                        formControlName="username"
                        [attr.placeholder]="'Enter username'">
                    <label id="login-field-password-text" 
                        for="login-field-password-input"
                        class="col-form-label">
                        Password <span class="text-danger">*</span>
                    </label>
                    <input id="login-field-password-input" type="password" class="form-control mb-2"
                        formControlName="password" placeholder="Password">
                    <div class="justify-content-center mt-4">
                        <button id="login-button" class="btn btn-orange d-block w-100" (click)=login()>LOGIN</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
    <div *ngIf=eventInfo class="text-center mt-2">
        <div id="login-contact-admin-text" 
            class="text-danger" 
            *ngIf="eventInfo.emailFrom">
            If you forgot password please contact {{eventInfo.emailFrom}}
        </div>
    </div>
</div>